import React from 'react';
import classnames from 'classnames';

class FramedPagination extends React.Component {
  handleClickPrev = () => {
    if (this.props.activeIndex > 0) {
      this.props.onChange(this.props.activeIndex - 1);
    }
  }

  handleClickNext = () => {
    if (this.props.activeIndex < this.props.totalSteps - 1) {
      this.props.onChange(this.props.activeIndex + 1);
    }
  }

  render() {
    const { activeIndex, totalSteps, theme, className, style } = this.props;
    return (
      <nav
        className={classnames('aui-pagination', className, { [`aui-theme-${theme}`]: theme })}
        style={style}
      >
        <ul className="aui-pagination__items">
          <li className="aui-pagination__item">
            <button type="button" className="aui-pagination__prev" onClick={this.handleClickPrev} disabled={activeIndex === 0}>
              <i className="aui-pagination__prev-icon">
                <svg viewBox="0 0 8 13"><path d="M1.5,1 l6,6 l-6,6" fill="none" stroke="#FCFCFD" strokeWidth="1.5" /></svg>
              </i>
              <span className="aui-sr-only">Previous</span>
            </button>
          </li>
          <li className="aui-pagination__item">
            <button type="button" className="aui-pagination__next" onClick={this.handleClickNext} disabled={activeIndex + 1 === totalSteps}>
              <i className="aui-pagination__next-icon">
                <svg viewBox="0 0 8 13"><path d="M1.5,1 l6,6 l-6,6" fill="none" stroke="#FCFCFD" strokeWidth="1.5" /></svg>
              </i>
              <span className="aui-sr-only">Next</span>
            </button>
          </li>
        </ul>
      </nav>
    );
  }
}

FramedPagination.defaultProps = {
  onChange: () => {},
  style: {},
  className: ''
};

export default FramedPagination;
